import { Languages } from "../../../enums/languages";

const checkBoxesForPardesHannaKarkurLang = {
    "cityResidentLabel": {
        [Languages.Hebrew]: { default: 'תושב.ת המועצה / בעלי עסקים' },
        [Languages.English]: { default: 'Council resident / Business owners' },
        [Languages.Arabic]: { default: 'سكان المجلس / أصحاب الأعمال' },
     },
    "municipalParkingLabel": {
        [Languages.Hebrew]: { default: 'עובד.ת מועצה או ביה"ס אלונים' },
        [Languages.English]: { default: 'Council employee or Alonim school' },
        [Languages.Arabic]: { default: 'موظف المجلس أو مدرسة ألونييم' }
    },
    "agriculturalSchoolFacultyLabel": {
        [Languages.Hebrew]: { default: 'סגל בית ספר חקלאי' },
        [Languages.English]: { default: 'Agricultural school faculty' },
        [Languages.Arabic]: { default: 'هيئة التدريس في المدرسة الزراعية' }
    },
    "collectionOrWaterDepartmentLabel": {
        [Languages.Hebrew]: { default: 'עובד.ת מחלקת גבייה/מים' },
        [Languages.English]: { default: 'Collection or Water Department employee' },
        [Languages.Arabic]: { default: 'موظف قسم التحصيل / المياه' }
    },
    "planningAndConstructionCommitteeLabel": {
        [Languages.Hebrew]: { default: 'חבר.ת ועדת תכנון ובנייה' },
        [Languages.English]: { default: 'Planning and Construction Committee member' },
        [Languages.Arabic]: { default: 'عضو لجنة التخطيط والبناء' }
    },
    "kindergartenElaAndAgosLabel": {
        [Languages.Hebrew]: { default: 'עובד.ת גן אלה/אגוז' },
        [Languages.English]: { default: 'Kindergarten Ela or Agos employee' },
        [Languages.Arabic]: { default: 'موظف روضة إيلا أو أغوز' }
    }
}

export default checkBoxesForPardesHannaKarkurLang;